import React from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/logo-csvbv.png";

export const Header: React.FC = () => {
  const [open, setOpen] = React.useState(false);

  const linkCls = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 rounded-md text-sm font-medium ${
      isActive ? "text-white bg-blue-600" : "text-gray-200 hover:text-white hover:bg-white/10"
    }`;

  return (
    <header className="bg-gray-900 text-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img
            src={logo}
            onError={(e) => ((e.currentTarget.style.display = "none"))}
            alt="CSVBV"
            className="w-9 h-9 rounded-full bg-white object-contain p-1"
          />
          <span className="font-bold">CSVBV</span>
        </Link>

        <nav className="hidden md:flex items-center gap-2">
          <NavLink to="/" className={linkCls} end>Accueil</NavLink>
          <NavLink to="/equipes" className={linkCls}>Équipes</NavLink>
          <NavLink to="/galerie" className={linkCls}>Galerie</NavLink>
          <NavLink to="/bureau" className={linkCls}>Bureau</NavLink>
          <NavLink to="/contact" className={linkCls}>Contact</NavLink>
        </nav>

        <button
          className="md:hidden inline-flex items-center justify-center w-9 h-9 rounded bg-white/10"
          onClick={() => setOpen((s) => !s)}
          aria-label="Ouvrir le menu"
        >
          <i className="ri-menu-line text-xl" />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10">
          <nav className="px-4 py-3 flex flex-col gap-2">
            <NavLink to="/" className={linkCls} onClick={() => setOpen(false)} end>Accueil</NavLink>
            <NavLink to="/equipes" className={linkCls} onClick={() => setOpen(false)}>Équipes</NavLink>
            <NavLink to="/galerie" className={linkCls} onClick={() => setOpen(false)}>Galerie</NavLink>
            <NavLink to="/bureau" className={linkCls} onClick={() => setOpen(false)}>Bureau</NavLink>
            <NavLink to="/contact" className={linkCls} onClick={() => setOpen(false)}>Contact</NavLink>
          </nav>
        </div>
      )}
    </header>
  );
};
